import { Component, Input } from '@angular/core';
import { ChainRepository, Trade } from 'common';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { heroArrowTurnDownRightMini } from '@ng-icons/heroicons/mini';
import { TradeFillsSankeyModalComponent } from './trade-fills-sankey-modal';

@Component({
  selector: 'common-rebalancing-trade-fills',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    NgIconComponent,
    TradeFillsSankeyModalComponent,
  ],
  providers: [
    provideIcons({
      heroArrowTurnDownRightMini,
    }),
  ],
  templateUrl: './trade-fills.component.html',
  styleUrls: ['./trade-fills.component.scss'],
})
export class TradeFillsComponent {
  @Input()
  public trade: Trade;

  public isSankeyModalOpen = false;

  constructor(public chainRepository: ChainRepository) {}

  public openSankeyModal(): void {
    this.isSankeyModalOpen = true;
  }
}
